export default __webpack_public_path__ + "static/media/staking-coins.3e72f359.png";